import type StudyModel from '../../../models/StudyModel';
import type StudyParticipantModel from '../../../models/StudyParticipantModel';
import { requestAndParse, requestSuccessful } from '../request';

const getStudy = async (id: number) => {
    const route = 'admin/get-study';
    const payload = { id };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const study = response.body?.study as StudyModel;
    const participants = (response.body?.participants ??
        []) as StudyParticipantModel[];

    return { success, study, participants };
};

export default getStudy;
